import React from "react";

const Contact = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M31.432 23.004c-1.959 0-3.883-.306-5.705-.909-.894-.304-1.992-.025-2.537.535l-3.598 2.716c-4.173-2.227-6.743-4.797-8.94-8.938l2.636-3.504c.685-.684.93-1.683.636-2.62a18.196 18.196 0 01-.912-5.716A2.57 2.57 0 0010.444 2H4.568A2.57 2.57 0 002 4.568C2 20.797 15.203 34 31.432 34A2.57 2.57 0 0034 31.432v-5.86a2.57 2.57 0 00-2.568-2.568z"
            fill={fill}
        />
    </svg>
);

export default Contact;
